import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { LoadingIndicatorComponent } from '../loading-indicator/loading-indicator.component';

@Component({
  selector: 'app-retryable-section',
  standalone: true,
  imports: [
    ButtonComponent,
    CommonModule,
    LoadingIndicatorComponent,
  ],
  templateUrl: './retryable-section.component.html',
  styleUrl: './retryable-section.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class RetryableSectionComponent {
  @Input({ required: true }) error: boolean;
  @Input() errorMessage = 'Ha ocurrido un problema al cargar la información. Por favor, reintenta.';
  @Input({ required: true }) loading: boolean;
  @Output() retry: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  retryAction(): void {
    this.retry.emit();
  }
}
